// import React, { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchGames } from './store/Slice';
// import { IoMdClose } from 'react-icons/io';
// import { Link } from 'react-router-dom';
// import Spinner from './Spinner';
// import Cookies from 'js-cookie'
// function GameDetails() {
//   const { gameid } = useParams();
//   console.log("GAMEIDD", gameid)
//   const dispatch = useDispatch();
//   const game = useSelector((state) =>
//     state.game.data.games.find((game) => game.gameid === gameid)
//   );

//   console.log("GAMES", game);

//   const msisdn=Cookies.get('msisdn')

//   useEffect(() => {
//     // Fetch games when the component mounts
//     dispatch(fetchGames());
//   }, [dispatch]);

//   if (!game) {
//     // return <p>Game not found</p>;
//     return(
//       <Spinner/>
//     )
//   }
  
//   return ( 
//     <div className="bg-black h-screen relative">
//       <Link to ={`/home?msisdn=${msisdn}`} className='absolute top-4 p-2 text-red-600'>
//         <IoMdClose size={30} />
//       </Link>

//       <div className='flex justify-center items-center bg-black h-screen'>
//         <iframe 
//           className='w-full h-screen p-2'
//           title={game.gamename}
//           src={game.gameurl}
//         ></iframe>
//       </div>
//     </div>
//   );
// }

// export default GameDetails;


// // import React, { useEffect, useState } from 'react';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { fetchGames } from './store/Slice';
// // import Header from './Header';
// // import GameCarousel from './GameCarousel';
// // import { Link, useLocation } from 'react-router-dom';
// // import spinner from '../../src/assets/images/spinner.gif';
// // import Lottie from 'react-lottie';
// // import * as animationDataa from '../assets/images/Animation - 1709103850899.json';

// // // --- GA helper (simple + safe) ---
// // const gtagSafe = (name, params = {}) => {
// //   if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
// //     window.gtag('event', name, params);
// //   }
// // };

// // function HomePage() {
// //   const dispatch = useDispatch();
// //   const location = useLocation();
// //   const state = useSelector((state) => state);
// //   const [showMore, setShowMore] = useState(false);

// //   // Count arrivals
// //   useEffect(() => {
// //     gtagSafe('screen_view', {
// //       firebase_screen: 'HomePage',
// //       screen_name: 'HomePage',
// //       page_path: window.location.pathname + window.location.search,
// //       hostname: window.location.hostname,
// //     });

// //     gtagSafe('home_page_view', {}); // custom marker for reporting
// //   }, [location.search]);

// //   useEffect(() => {
// //     dispatch(fetchGames());
// //   }, [dispatch]);

// //   if (state.game.isLoading) {
// //     return (
// //       <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center">
// //         <img
// //           className="min-w-full min-h-full object-fill"
// //           alt="background"
// //           src={spinner}
// //         />
// //       </div>
// //     );
// //   }

// //   // Group games by category
// //   const gamesByCategory = {};
// //   state.game.data.games.forEach((game) => {
// //     if (!gamesByCategory[game.category]) {
// //       gamesByCategory[game.category] = [];
// //     }
// //     gamesByCategory[game.category].push(game);
// //   });

// //   const categories = state.game.data.category?.map((cat) => cat.cat_name);
// //   const initialCategories = categories?.slice(0, 3);
// //   const categoriesToShow = showMore ? categories : initialCategories;

// //   const defaultOptionss = {
// //     loop: true,
// //     autoplay: true,
// //     animationData: animationDataa.default,
// //     rendererSettings: {
// //       preserveAspectRatio: 'xMidYMid slice',
// //     },
// //   };

// //   // Track game clicks
// //   const onGameClick = (game) => {
// //     gtagSafe('game_click', {
// //       game_id: game.gameid,
// //       game_name: game.gamename,
// //       category: game.category,
// //     });
// //   };

// //   return (
// //     <div className="h-screen flex flex-col overflow-hidden">
// //       <Header category={state.game.data.category} />
// //       <div className="flex-grow overflow-y-auto bg-black">
// //         {/* Hero section */}
// //         <div className="relative lg:h-screen lg:flex flex flex-cols lg:justify-between items-center">
// //           <h1 className="text-green-300 absolute lg:left-0 left-12 ml-4 lg:text-6xl text-3xl mt-56 lg:mt-0" style={{ fontFamily: "Jacques Francois Shadow", fontWeight: 'bold' }}>GAMEOFYY</h1>
// //           <h1 className="text-white absolute lg:left-0 left-14 ml-4 lg:text-4xl text-2xl lg:mt-32 mt-72" style={{ fontFamily: "Aclonica", fontWeight: 'semibold' }}>Video Games Online</h1>
// //           <Lottie options={defaultOptionss} height={400} width={480} />
// //         </div>

// //         <GameCarousel games={state.game.data.games} />

// //         {/* Categories */}
// //         {categoriesToShow?.map((categoryName) => {
// //           const trimmedCategoryName = categoryName.trim();
// //           return (
// //             <div key={trimmedCategoryName} className="bg-black lg:p-9 md:p-5 sm:p-4 p-3">
// //               <h1 className="text-2xl lg:p-0 p-2 lg:px-4 lg:py-3 text-amber-400 border-b border-gray-700 bg-zinc-900 rounded-lg font-sans font-bold relative">
// //                 {trimmedCategoryName} Games
// //               </h1>
// //               <div className="lg:mx-6 lg:mt-8 grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-4 lg:gap-8">
// //                 {gamesByCategory[trimmedCategoryName]?.map((game) => (
// //                   <div key={game.gameid} className={`relative ${game.category} group`}>
// //                     <div className="mt-6 shadow-lg shadow-white transition-transform duration-300 transform scale-100 group-hover:scale-105">
// //                       <img
// //                         className="rounded-t object-full rounded-lg lg:h-[280px] lg:w-[300px] md:h-[260px] sm:h-[200px] h-[180px] w-[200px] overflow-hidden mx-auto"
// //                         src={game.imgurlnew}
// //                         alt={game.gamename}
// //                       />
// //                       <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
// //                         <Link to={`/home/games/${game.gameid}`} onClick={() => onGameClick(game)}>
// //                           <button className="bg-amber-400 text-white lg:px-3 lg:py-3 px-2 py-2 rounded-lg font-semibold">
// //                             Play Now
// //                           </button>
// //                         </Link>
// //                       </div>
// //                       <div className="absolute bottom-0 left-0 w-full bg-amber-300 uppercase rounded-b lg:px-4 lg:py-4 px-1 py-2 text-black text-center font-semibold">
// //                         {game.gamename.slice(0, 15)}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// // export default HomePage;





import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchGames } from "./store/Slice";
import { IoMdClose } from "react-icons/io";
import Spinner from "./Spinner";
import Cookies from "js-cookie";

function GameDetails() {
  const { gameid } = useParams();
  const dispatch = useDispatch();
  const msisdn = Cookies.get("msisdn");

  // Convert URL param to number (IMPORTANT FIX)
  const numericGameId = Number(gameid);

  // Safely access games array
  const games = useSelector((state) => state.game?.data?.games || []);
  const loading = useSelector((state) => state.game?.loading);

  const game = games.find((g) => g.gameid === numericGameId);

  useEffect(() => {
    // Fetch games only if not already loaded
    if (!games.length) {
      dispatch(fetchGames());
    }
  }, [dispatch, games.length]);

  // Show spinner while loading or if game not found yet
  if (loading || !game) {
    return <Spinner />;
  }

  return (
    <div className="bg-black h-screen relative">
      <Link
        to={`/home?msisdn=${msisdn}`}
        className="absolute top-4 left-4 p-2 text-red-600 z-50"
      >
        <IoMdClose size={30} />
      </Link>

      <div className="flex justify-center items-center bg-black h-screen">
        <iframe
          className="w-full h-screen p-2"
          title={game.gamename}
          src={game.gameurl}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default GameDetails;